import actionTypes from '../actionTypes';
export default {
  setEmail: data => dispatch => {
    dispatch({
      type: actionTypes.EMAIL,
      payload: data
    });
  },
  setSms: data => dispatch => {
    dispatch({
      type: actionTypes.SMS,
      payload: data
    });
  },
  setActiveTab: data => dispatch => {
    dispatch({
      type: actionTypes.ACTIVE_TAB,
      payload: data
    })
  }
};


// WEBPACK FOOTER //
// src/store/action/smsemail.action.js